import {
  PDFLabelSections,
  type PDFLabelSectionEnum,
} from '../enums/PDFLabelSectionEnum'

export interface PDFLabelFieldMetadataConstructor {
  fieldKey: string
  defaultLabel: string
  section: PDFLabelSectionEnum
  maxLength: number
  isCustomFieldLabel: boolean
}

export class PDFLabelFieldMetadata {
  readonly fieldKey: string
  readonly defaultLabel: string
  readonly section: PDFLabelSectionEnum
  readonly maxLength: number
  readonly isCustomFieldLabel: boolean

  constructor(data: PDFLabelFieldMetadataConstructor) {
    this.fieldKey = data.fieldKey
    this.defaultLabel = data.defaultLabel
    this.section = data.section
    this.maxLength = data.maxLength
    this.isCustomFieldLabel = data.isCustomFieldLabel
  }

  // Which PDFLabelSet.value map this field's override lives in
  get translationType(): 'po' | 'orderitem' {
    return this.section === PDFLabelSections.ITEM_FIELDS ? 'orderitem' : 'po'
  }
}
